import * as graphql from '@treams/treams-network';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'url') {
		return {
			title: 'Salesforce-URL',
			description:
				'Vul de mydomain-URL van de organisatie in, bijvoorbeeld https://jouworganisatie.my.salesforce.com. De nachtelijke sync logt op die URL in met de API key en API secret.',
		};
	}

	if (key === 'clientID') {
		return {
			title: 'API Key',
			description: 'Vul de API key in die je van HR2day hebt ontvangen.',
		};
	}

	if (key === 'clientSecret') {
		return {
			title: 'API Secret',
			description: 'Vul de API secret in die je van HR2day hebt ontvangen.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

export default function HR2Day() {
	return (
		<ProductLayout
			id="hr2day"
			type={graphql.ConnectorType.Hr2Day}
			headerImageURL="https://assets.ontreams.com/marketplace/hr2day-wide.jpg"
			translate={translate}
		/>
	);
}

export function HR2DayTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="hr2day"
			title="HR2day"
			description="Al je HR-processen vanuit één centrale database."
			logoImageURL="https://assets.ontreams.com/marketplace/hr2day.png"
			selected={props.selected}
		/>
	);
}
